class Renderer {
    constructor(data, type, row, meta, config) {
        this.data = data;
        this.type = type;
        this.row = row;
        this.meta = meta;
        this.config = config;
    }

    render() { }
}

export default Renderer;
